webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(1);




var KEY = 'teamV0100';
var t = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({

  EDIT: 0,
  START: 1,
  PLAYING: 2,
  PAUSED: 3,
  END: 4,

  fetch: function fetch(old) {
    if (t === undefined) {
      t = JSON.parse(localStorage.getItem(KEY)) || old;
    }
    return t;
  },
  save: function save(current) {
    localStorage.setItem(KEY, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(current));
  },


  newPlayer: function newPlayer(name, id) {
    return {
      id: id !== undefined ? id : __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].data.uid++,
      playerName: name,
      start: 0,
      secondsOn: 0,
      totalOn: 0,
      totalOff: 0,
      sessionOn: 0,
      sessionOff: 0,
      isOn: -1
    };
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: {
    uid: 1000,
    gameState: __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].EDIT,
    endGameWarning: false,
    timeStart: 0,
    timeSync: new Date().getTime(),
    totalGameTime: 0,
    totalPaused: 0,

    players3: [],

    logList: [],
    logId: 0
  }
});

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(26),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72ef3002",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Team__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Game__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Game__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Game___default.a,
    name: 'FairPlay'
  }, {
    path: '/edit-players',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Team___default.a,
    props: { visibility: 'active' }
  }]
}));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(24),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(6);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(0);





window.addEventListener('touchstart', function onFirstTouch() {
  var d = document.documentElement;
  d.className = d.className.replace(/\bno-touch\b/, '');

  window.user_touched = true;

  window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].data = __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].fetch(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].data);

setInterval(function () {
  return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].save(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].data);
}, 1000);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_javascript_natural_sort__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_javascript_natural_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_javascript_natural_sort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Team_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Team_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Team_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(0);







var padLeft = function padLeft(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
};
function timeRounded(syncWith) {
  var now = new Date().getTime();

  var dif = Math.round((now - syncWith) / 1000) * 1000;
  return new Date(syncWith + dif).getTime();
}
var _formatTime = function _formatTime(secs) {
  var min = Math.floor(secs / 60);
  var sec = secs - min * 60;
  return min + ':' + padLeft(sec, '0', 2);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var o = {
      currentGameTime: 0,
      currentPaused: 0,
      timeSync: 0
    };
    o.common = __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */];
    o.sharedStore = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].data;
    return o;
  },

  components: {
    Team: __WEBPACK_IMPORTED_MODULE_1__Team_vue___default.a
  },
  beforeCreate: function beforeCreate() {},


  computed: {
    playersFiltered: function playersFiltered() {
      var off = this.sharedStore.players3.filter(function (p) {
        return p.isOn !== 1;
      }).sort(this.timeSort);
      var on = this.sharedStore.players3.filter(function (p) {
        return p.isOn === 1;
      }).sort(this.timeSort);
      return off.concat(on);
    }
  },
  filters: {
    formatTime: function formatTime(secs) {
      return _formatTime(secs);
    },
    logFormatTime: function logFormatTime(secs) {
      return secs > 0 ? _formatTime(secs) + '' : 'Starts';
    },
    logFormatDesc: function logFormatDesc(log) {
      return log['logTotalOn'] > 0 ? log['logDesc'] : '';
    },
    pluralize: function pluralize(n) {
      return n === 1 ? '' : 's';
    }
  },
  methods: {
    startGame: function startGame() {
      this.sharedStore.timeStart = timeRounded(this.sharedStore.timeSync);
      this.calcTime(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PLAYING);
    },
    pausePlay: function pausePlay() {
      this.sharedStore.endGameWarning = false;
      this.calcTime(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PAUSED);
    },
    resumePlay: function resumePlay() {
      this.calcTime(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PLAYING);
    },
    endGame: function endGame() {
      var _this = this;

      if (this.sharedStore.endWarning) {
        this.sharedStore.endWarning = false;
        this.calcTime(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].END);
      } else {
        this.sharedStore.endWarning = true;
        window.setInterval(function () {
          if (_this.sharedStore.endWarning) {
            _this.sharedStore.endWarning = false;
          }
        }, 3000);
      }
    },
    savePlayers: function savePlayers() {
      this.sharedStore.gameState = __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].START;
    },
    editPlayers: function editPlayers() {
      this.sharedStore.gameState = __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].EDIT;
    },
    clearGame: function clearGame() {
      this.sharedStore.gameState = __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].START;
      this.sharedStore.players3 = this.sharedStore.players3.map(function (player) {
        return __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].newPlayer(player.playerName, player.id);
      });
      this.sharedStore.logId = 0;
      this.sharedStore.logList = [];
      this.sharedStore.timeStart = 0;
      this.sharedStore.totalGameTime = 0;
      this.sharedStore.totalPaused = 0;

      this.currentGameTime = 0;
      this.currentPaused = 0;
    },
    calcTime: function calcTime(state) {
      var _this2 = this;

      this.sharedStore.gameState = state;
      var now = timeRounded(this.sharedStore.timeSync);
      var dif = this.secDif(this.sharedStore.timeStart, now);
      this.sharedStore.timeStart = timeRounded(this.sharedStore.timeSync);
      if (this.sharedStore.gameState === __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PLAYING || this.sharedStore.gameState === __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].END) {
        this.sharedStore.totalPaused += dif;
        var _now = timeRounded(this.sharedStore.timeSync);
        this.sharedStore.players3.forEach(function (v, i) {
          v.start = _now;
        });
      } else {
        this.sharedStore.totalGameTime += dif;
        this.sharedStore.players3.forEach(function (v, i) {
          if (v.isOn === 1) {
            v.totalOn += _this2.secDif(v.start, now);
          } else {
            v.totalOff += _this2.secDif(v.start, now);
          }
        });
      }
    },
    timeSort: function timeSort(a, b) {
      return a.secondsOn < b.secondsOn ? 1 : -1;
    },
    updateData: function updateData() {
      var _this3 = this;

      var now = timeRounded(this.sharedStore.timeSync);
      this.sharedStore.players3.forEach(function (v, i) {
        v.secondsOn = v.totalOn;
        if (v.isOn === 1 && _this3.sharedStore.gameState === __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PLAYING) {
          v.secondsOn += _this3.secDif(v.start, now);
        }
      });
      this.currentGameTime = this.sharedStore.totalGameTime + (this.sharedStore.gameState === __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PLAYING ? this.secDif(this.sharedStore.timeStart, now) : 0);
      this.currentPaused = this.sharedStore.totalPaused + (this.sharedStore.gameState === __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PAUSED ? this.secDif(this.sharedStore.timeStart, now) : 0);
    },
    secDif: function secDif(start, end) {
      return Math.floor((end - start) / 1000);
    },
    clickPlayer: function clickPlayer(player) {
      if (this.sharedStore.gameState === __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].END) {
        return;
      }

      var now = timeRounded(this.sharedStore.timeSync);

      var dif = 0;
      if (this.sharedStore.gameState === __WEBPACK_IMPORTED_MODULE_3__common__["a" /* default */].PLAYING) {
        dif = this.secDif(player.start, now);
      }
      player.start = now;

      if (player.isOn === 1) {
        player.isOn = 0;
        player.totalOn += dif;
      } else {
        player.isOn = 1;
        player.totalOff += dif;
      }

      this.sharedStore.logList.unshift({
        'id': this.sharedStore.logId++,
        'logPlayer': player,
        'logTime': this.currentGameTime,
        'logDesc': player.isOn === 1 ? 'On' : 'Off',
        'logTotalOn': player.totalOn
      });
    }
  },
  created: function created() {
    this.sharedStore.players3.sort(__WEBPACK_IMPORTED_MODULE_0_javascript_natural_sort___default.a);
    this.updateData();
  },
  mounted: function mounted() {
    window.setInterval(this.updateData, 100);
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {},

  data: function data() {
    var newPlayerEnt = this.newPlayer('');
    return {
      newPlayerEnt: newPlayerEnt,
      editingName: false,
      sharedStore: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].data
    };
  },
  beforeCreate: function beforeCreate() {},

  watch: {},

  computed: {
    playersWithNew: function playersWithNew() {
      return this.sharedStore.players3.concat(this.newPlayerEnt);
    }
  },

  filters: {},

  methods: {

    newPlayer: function newPlayer(name, id) {
      return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].newPlayer(name, id);
    },

    newPlaceholder: function newPlaceholder(p) {
      return this.sharedStore.players3.indexOf(p) === -1 ? 'Enter a New Players Name' : '';
    },


    isStart: function isStart() {
      return this.sharedStore.players3.length === 0;
    },

    editPlayer: function editPlayer(player) {
      if (player !== this.editingName) {
        this.beforeEditCache = player.playerName;
        this.editingName = player;
      }
      this.checkNew(player);
    },

    checkNew: function checkNew(player) {
      if (player.playerName && this.sharedStore.players3.indexOf(player) === -1) {
        this.sharedStore.players3.push(player);
        this.newPlayerEnt = this.newPlayer('');
      }
    },


    doneEdit: function doneEdit(player, enter) {
      if (this.editingName !== player) {
        this.checkNew(player);
        return;
      }
      player.playerName = player.playerName.trim();
      if (player.playerName === '' && this.sharedStore.players3.indexOf(player) !== -1) {
        this.deletePlayer(player);
      }

      if (enter === true && this.sharedStore.players3.indexOf(player) === this.sharedStore.players3.length - 1) {
        this.editingName = this.newPlayerEnt;
      } else {
        this.editingName = false;
      }
    },

    deletePlayer: function deletePlayer(player) {
      this.sharedStore.players3.splice(this.sharedStore.players3.indexOf(player), 1);
    },


    cancelEdit: function cancelEdit(player) {
      player.playerName = this.beforeEditCache;
      this.editingName = false;
    }

  },

  directives: {
    'player-focus': function playerFocus(el, binding) {
      if (binding.value) {
        el.focus();
      }
    }
  }
});

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(16)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(25),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6cf06717",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.START),
      expression: "sharedStore.gameState == common.START"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-on",
    on: {
      "click": function($event) {
        _vm.startGame()
      }
    }
  }, [_vm._v("\n            Start a New Match\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.PLAYING),
      expression: "sharedStore.gameState == common.PLAYING"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.pausePlay()
      }
    }
  }, [_vm._v("\n            Stop Play\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.PAUSED),
      expression: "sharedStore.gameState == common.PAUSED"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.resumePlay()
      }
    }
  }, [_vm._v("\n            Start Play\n        ")])]), _vm._v(" "), _c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.END),
      expression: "sharedStore.gameState == common.END"
    }],
    staticClass: "top-buttons heading"
  }, [_vm._v("\n        End of Play\n    ")]), _vm._v(" "), (_vm.sharedStore.gameState > _vm.common.START) ? _c('section', [_c('section', {
    class: {
      'is-stopped': _vm.sharedStore.gameState != _vm.common.PLAYING, 'is-paused': _vm.sharedStore.gameState == _vm.common.PAUSED, 'is-end': _vm.sharedStore.gameState == _vm.common.END
    }
  }, [_c('div', {
    staticClass: "time-desc"
  }, [_vm._v("\n                Game Time\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "time-large"
  }, [_vm._v("\n                " + _vm._s(_vm._f("formatTime")(_vm.currentGameTime)) + "\n            ")])]), _vm._v(" "), _c('section', {
    class: {
      'hidden': _vm.currentPaused < 1
    }
  }, [_c('div', {
    staticClass: "time-paused",
    class: {
      'time-paused-paused': _vm.sharedStore.gameState == _vm.common.PAUSED, 'time-paused-paused-flash': _vm.sharedStore.gameState == _vm.common.PAUSED && _vm.currentPaused % 2
    }
  }, [_vm._v("\n                Play Stopped for " + _vm._s(_vm._f("formatTime")(_vm.currentPaused)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (_vm.sharedStore.gameState === _vm.common.EDIT) ? _c('team') : _vm._e(), _vm._v(" "), (_vm.sharedStore.gameState >= _vm.common.START) ? _c('section', [_c('transition-group', {
    staticClass: "players",
    attrs: {
      "name": "anim-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.playersFiltered), function(player) {
    return _c('li', {
      key: player.id,
      staticClass: "player",
      class: {
        'player-on': player.isOn === 1, 'player-time-stopped': _vm.sharedStore.gameState != _vm.common.PLAYING
      },
      on: {
        "click": function($event) {
          _vm.clickPlayer(player)
        }
      }
    }, [_c('strong', {
      staticClass: "left-col player-name"
    }, [_vm._v(_vm._s(player.playerName))]), _vm._v(" "), _c('span', {
      staticClass: "right-col player-seconds"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(player.secondsOn)))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.PAUSED),
      expression: "sharedStore.gameState == common.PAUSED"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.endGame()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.sharedStore.endWarning ? "Are you sure?" : "End Game") + "\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.START),
      expression: "sharedStore.gameState == common.START"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.editPlayers()
      }
    }
  }, [_vm._v("\n            Add or Change Players\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.EDIT && _vm.sharedStore.players3.length > 0),
      expression: "sharedStore.gameState == common.EDIT && sharedStore.players3.length > 0"
    }]
  }, [_c('button', {
    staticClass: "button-large button-large-on",
    on: {
      "click": function($event) {
        _vm.savePlayers()
      }
    }
  }, [_vm._v("\n            Done Editing,\n            " + _vm._s(_vm.sharedStore.players3.length) + " Player" + _vm._s(_vm._f("pluralize")(_vm.sharedStore.players3.length)) + "…\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharedStore.gameState == _vm.common.END),
      expression: "sharedStore.gameState == common.END"
    }],
    staticClass: "top-buttons"
  }, [_c('button', {
    staticClass: "button-large button-large-min",
    on: {
      "click": function($event) {
        _vm.clearGame()
      }
    }
  }, [_vm._v("\n            Clear Game and Start Over\n        ")])]), _vm._v(" "), (_vm.sharedStore.gameState >= _vm.common.START && _vm.sharedStore.logList.length) ? _c('section', [_c('h4', {
    staticClass: "sub-log-title"
  }, [_vm._v("\n            Substitution" + _vm._s(_vm._f("pluralize")(_vm.sharedStore.logList.length)) + "\n            "), _c('span', {
    staticClass: "sub-log-title-right"
  }, [_vm._v("Time On")])]), _vm._v(" "), _c('ul', {
    staticClass: "sub-log"
  }, _vm._l((_vm.sharedStore.logList), function(log) {
    return _c('li', {
      key: _vm.sharedStore.logList['id'],
      staticClass: "sub-log-li"
    }, [_c('strong', {
      staticClass: "left-col player-name"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("formatTime")(log['logTime'])) + " " + _vm._s(log['logPlayer'].playerName) + " " + _vm._s(_vm._f("logFormatDesc")(log)) + "\n                ")]), _vm._v(" "), _c('span', {
      staticClass: "right-col"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("logFormatTime")(log['logTotalOn'])) + "\n                ")])])
  }))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team"
  }, [_c('div', {
    staticClass: "top-buttons"
  }, [_c('h1', {
    staticClass: "heading"
  }, [(_vm.isStart) ? _c('span', [_vm._v("\n              Add Players to Start\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.isStart) ? _c('span', [_vm._v("\n              Add or Change Players\n            ")]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "players-ul"
  }, _vm._l((_vm.playersWithNew), function(player) {
    return _c('li', {
      key: player.id,
      staticClass: "players-li",
      class: {
        'player-editing': player == _vm.editingName || player.playerName === ''
      }
    }, [_c('div', {
      staticClass: "player-name"
    }, [_c('span', {
      staticClass: "player-name-text",
      on: {
        "click": function($event) {
          _vm.editPlayer(player)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(player.playerName) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "player-delete",
      on: {
        "click": function($event) {
          _vm.deletePlayer(player)
        }
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (player.playerName),
        expression: "player.playerName"
      }, {
        name: "player-focus",
        rawName: "v-player-focus",
        value: (player == _vm.editingName),
        expression: "player == editingName"
      }],
      staticClass: "player-edit",
      attrs: {
        "type": "text",
        "placeholder": _vm.newPlaceholder(player)
      },
      domProps: {
        "value": (player.playerName)
      },
      on: {
        "blur": function($event) {
          _vm.doneEdit(player)
        },
        "keyup": [function($event) {
          _vm.editPlayer(player)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.doneEdit(player, true)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
          _vm.cancelEdit(player)
        }],
        "click": function($event) {
          _vm.editPlayer(player)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(player, "playerName", $event.target.value)
        }
      }
    })])
  }))])
},staticRenderFns: []}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.c5074e36c2bce35a3e95.js